import { CommercialTermsData } from '../../store/rfqSlice';
import { CriteriaPointer } from '../../types/criteriaPointers';
import { notesChip, pointerChips, structuredCriteriaChips } from '../../utils/criteriaChips';

/**
 * Sample sourcing criteria for the /design galleries, run through the real
 * chip mapping so the gallery shows exactly what the app would.
 */
export const SAMPLE_TERMS: CommercialTermsData = {
  desiredLeadTime: '4-6 weeks',
  paymentTerms: '',
  deliveryLocation: 'Hinjewadi Phase 1, Pune, Maharashtra 411057, India',
  sourcingLocation: '',
  complianceRequirements: ['RoHS', 'CE Marking'],
  additionalRequirements:
    'Keep the whole BOM under ₹4 lakh. No suppliers from outside India please. Ideally buy the motors and their drivers from one vendor.',
  supplierPriority: JSON.stringify(['price', 'quality', 'reliability']),
};

export const SAMPLE_POINTERS: CriteriaPointer[] = [
  { label: 'Budget ≤ ₹4L', kind: 'BUDGET', value: 400000, currency: 'INR', appliesTo: 'ALL', quote: 'Keep the whole BOM under ₹4 lakh' },
  { label: 'India-only suppliers', kind: 'PREFER_REGION', appliesTo: 'ALL', quote: 'No suppliers from outside India please' },
  { label: 'Motors + drivers together', kind: 'BUNDLE', appliesTo: ['COMP-1', 'COMP-2'], quote: 'Ideally buy the motors and their drivers from one vendor' },
];

export const SAMPLE_CRITERIA_CHIPS = structuredCriteriaChips(SAMPLE_TERMS);
export const SAMPLE_NOTE_CHIPS = pointerChips(SAMPLE_POINTERS);
/** Pointers pending or unavailable: the buyer's notes stand in for them. */
export const SAMPLE_CHIPS_WITH_NOTES = [...SAMPLE_CRITERIA_CHIPS, ...notesChip(SAMPLE_TERMS.additionalRequirements)];
